<template>
  <div class=" is-fullwidth">
    <div class="level">
        <div class="level-left">
          <div class="columns" >
              

             <div class=" col">
                &nbsp;<input type="date" class="input" v-model="start_date" />
                
              </div>
              <div class=" col" >
                &nbsp;<input type="date" class="input" v-model="end_date" />
                
              </div>

              
            </div>
      </div>
        
      </div>
    
   <div class="tabs is-boxed">
        <ul>
            <li v-bind:class="{'is-active': tab === 'results' }" @click="tab='results'"><a>Results</a></li>
           <li v-bind:class="{'is-active': tab === 'orders' }" @click="tab='orders'"><a>Orders</a></li>
           
        </ul>
    </div>

    <div v-if="tab ==='results'">
        <p v-if="orders_loading===true">Loading ...</p>
        <div v-if="orders_loading===false">
            <p>Total Orders Marked as Repeat In Time Period : <strong>{{ orders.length }}</strong> ( {{ total_order_qty }} garments)</p>
            <br />
            <table class="table is-hoverable is-fullwidth" id="orderstable" >
                <thead>
                    <tr>
                <th>Location</th>
                <th>Number</th>
                <th>Total Garments</th>
                
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in locations" :key="row.id">
                        <td><span @click="viewLocationOrders(row.id)">{{ row.name }}</span></td>
                        <td>{{ row.counter }}</td>
                        <td>{{ row.total_qtys }}</td>
                        </tr>
                </tbody>
                </table>

        </div>
    </div>

    <div v-if="tab === 'orders'">
        <div class="select is-pulled-right">
            <select  v-model="selected_location_id">
                  <option value="">Filter By Location</option>
                  <option v-bind:value="row.id" v-for="row in locations" :key="row.id">{{ row.name }}</option>
                  
          </select>
          </div>
        <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" >
            <thead>
                <tr>
            <th>PO Number</th>
            <th>Customer</th>
            <th>Garment</th>
            <th>Qty</th>
            <th>Design</th>
            <th>Date Set</th>
            <th>Location</th>
            
            <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="orders_loading===true">
            <td colspan="7"><strong>Loading orders ...</strong></td>
            </tr>
            <tr v-for="(order, index) in filteredOrders" v-bind:key="index" v-show="orders_loading===false">
            <td >{{order.ponumber}}</td>
            <td>{{order.clientname}}</td>
            <td>{{order.garmentname}}</td>
            <td>{{order.total_qty}}</td>
            <td>{{order.designname}}</td>
            <td>{{order.date}}</td>
            <td>{{ order.location_name }}</td>
            
            <td>
                <a :href="VUE_APP_ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-info is-small">View</button></a>
            </td>
            
                
                
                </tr>
        </tbody>
        
        </table>

        <button @click="exportXLS()" class="button is-info" >Export to Excel</button>
    </div>

     
    
  </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
//import SalesService from '@/services/SalesService.js';
import XLSX from 'xlsx';

export default {
  name:'ArtworkFinishedReport',
  components: {
   	
  },
  data() {
    return {
      client_id: '',
       clients: [],
      orders: [],
       selected_location_id: '',
      username: '',
      start_date: this.getStartDate(),
        end_date: new Date().toISOString().slice(0,10),
      currentSort: 'count',
      currentSortDir: 'desc',
      
     accessToken: '',
     orders_loading:true,
     VUE_APP_ASP_URL:process.env.VUE_APP_ASP_URL,
     tab : 'results',
    

     
    }
  },
  created() {
      this.getAccessToken()
        .then(() => { 
            this.getOrders()
        });
      
    },
  methods: {
    async getAccessToken() {
        this.accessToken = await this.$auth.getTokenSilently()
    },
    exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('orderstable'), {sheet:"Sheet 1"});
		 XLSX.writeFile(wb, 'Repeat Artworks Report.xlsx')

	 },
   
    async getOrders() {
      this.orders_loading=true;
      OrderService.getRepeatArtworks(this.accessToken, this.start_date, this.end_date)
          .then(
            (orders => {
              
              this.$set(this, "orders", orders);
              this.orders_loading=false;
            }).bind(this)
          );
    },
    
    getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() - 30);
            return d.toISOString().slice(0,10);
             
    },
    viewLocationOrders(location_id)
    {
        this.selected_location_id=location_id
        this.tab = 'orders'
    }

   
  },
  computed : {
     total_order_qty() {
        let total = this.orders.reduce(function (previousValue, currentValue) {
          return previousValue + currentValue.total_qty;
        }, 0);

        return total;
     },
     locations() {
         let filteredLocations = []

         this.orders.forEach(order => {      
            
            let location = filteredLocations.find(location => location.id === order.print_location_id);
            if(location)
            {
                location.counter++
                location.total_qtys += order.total_qty
            }
            else{
                let thisLocation = {'id' : order.print_location_id, 'name' : order.location_name, 'counter' : 1, "total_qtys" : order.total_qty}
                filteredLocations.push(thisLocation)
            }
            
        });

         return filteredLocations
     },
     filteredOrders: function () {
       let filteredOrders = []

        if(this.selected_location_id != "")
          {
            filteredOrders = this.orders.filter(row => row.print_location_id === this.selected_location_id)
          }
          else
          {
              filteredOrders = this.orders
          }

          return filteredOrders
       
     },
     
  },

 
  mounted() {
    
  },
  watch: {
   
    start_date: function () {
     
      this.getOrders()
    },
    end_date: function () {
     
      this.getOrders()
    },
  }
}



</script>


